import { Font, StyleSheet } from "@react-pdf/renderer";
import ARIAL_REGULAR from "assets/font/Arial_Regular.TTF";
import ARIAL_BOLD from "assets/font/Arial_Bold.TTF";

Font.register({
  family: "Arial",
  fonts: [
    {
      src: ARIAL_REGULAR,
      fontWeight: "normal",
    },
    {
      src: ARIAL_BOLD,
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingVertical: "5px",
    paddingHorizontal: "1px",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  mainContainer: {
    flex: 1,
  },
  mainDetails: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderColor: "#A0A0A0",
    paddingBottom: "2px",
  },
  leftSide: {
    flex: 1,
    alignItems: "flex-end",
  },
  rightSide: {
    flex: 1,
    marginLeft: "6px",
  },
  upperText: {
    fontSize: 10,
    marginTop: "2px",
    fontFamily: "Arial",
    fontWeight: "normal",
  },
  upperTextCenter: {
    fontSize: 10,
    marginTop: "2px",
    fontFamily: "Arial",
    fontWeight: "normal",
    textAlign: "center",
  },
  rotateBox1: {
    position: "absolute",
    transform: "rotate(-90deg)",
    left: "-62px",
    height: "20px",
    width: "150px",
    alignItems: "center",
  },
  rotateBox2: {
    position: "absolute",
    transform: "rotate(-90deg)",
    left: "-62px",
    height: "20px",
    width: "150px",
    alignItems: "center",
  },
  bold: {
    fontWeight: "bold",
  },
  dateContainer: {
    position: "absolute",
    width: 200,
    left: "5px",
  },
  dateText: {
    fontSize: 7,
    marginTop: "3px",
    fontFamily: "Arial",
    fontWeight: "normal",
  },
  tableContainer: {
    flex: 1,
  },
  flexOne: {
    flex: 1,
  },
  flexTwo: {
    flex: 2,
  },
  flexFour: {
    flex: 4,
  },
  flexFive: {
    flex: 4.8,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#e9e8e8",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderColor: "gray",
  },
  flexNine: {
    flex: 8.7,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#e9e8e8",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderColor: "gray",
  },
  flex20: {
    flex: 18,
  },
  secondFlexTwo: {
    flex: 1.9,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "gray",
    justifyContent: "center",
    alignItems: "center",
  },
  secondFlexFour: {
    flex: 3.8,
    backgroundColor: "#e9e8e8",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "gray",
    justifyContent: "center",
    alignItems: "center",
  },
  innerFour: {
    marginVertical: "2px",
    marginHorizontal: "2px",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50px",
  },
  secondFlex20: {
    flex: 17.4,
    borderBottomWidth: 1,
    borderColor: "gray",
  },
  inner20: {
    marginVertical: "2px",
    marginHorizontal: "5px",
  },
  firstSectionFirstRow: {
    backgroundColor: "#1a1919",
    height: "18px",
    justifyContent: "center",
    alignItems: "center",
    borderLeftWidth: 1,
    borderColor: "gray",
  },
  firstSection: {
    flexDirection: "row",
  },
  secondSection: {
    flexDirection: "row",
  },
  yellowText: {
    fontSize: 10,
    fontFamily: "Arial",
    fontWeight: "bold",
    color: "#ffbe1d",
  },
  knowledgeHeadingCont: {
    flex: 1,
    backgroundColor: "#bfbdbc",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderColor: "gray",
    justifyContent: "center",
    overflow: "hidden",
  },
  knowledgeDetailsCont: {
    flex: 26,
    backgroundColor: "white",
    borderColor: "gray",
  },
  secondSectionRow: {
    flexDirection: "row",
  },
  footerContainer: {
    flexDirection: "row",
    height: "50px",
  },
});

export default styles;
